const publicUrl = process.env.PUBLIC_URL || "";

export const imgFrame234 = `${publicUrl}/assets/hero-bg.png`;
export const imgLadyJustice = `${publicUrl}/assets/lady-justice.png`;
export const imgDashboard = `${publicUrl}/assets/dashboard.png`;
export const imgAvatar = `${publicUrl}/logo192.png`;
export const imgNbaLogo = `${publicUrl}/assets/nba-logo.png`;
export const imgContactLady = `${publicUrl}/assets/lady-justice.png`;
export const imgPartner2 = `${publicUrl}/assets/partner-2.png`;
export const imgPartner3 = `${publicUrl}/assets/partner-3.png`;
export const imgPartner5 = `${publicUrl}/assets/partner-5.png`;
export const imgPartner6 = `${publicUrl}/assets/partner-6.png`;
